import React from 'react';
import { CircularProgress } from 'material-ui';

export default ({ loading, text, style = {} }) => (
  <div
    style={{
      display: loading ? 'block' : 'none',
      height: '100%',
      width: '100%',
      position: 'fixed',
      zIndex: 30,
      top: 0,
      left: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      overflowX: 'hidden',
      transition: '0.5s',
      textAlign: 'center',
      paddingTop: '20%',
      ...style,
    }}
  >
    <CircularProgress size={100} thickness={7} />
    <div style={{ fontSize: '20px', color: 'white', marginTop: '24px', whiteSpace: 'pre-wrap', width: '50%', margin: 'auto' }}>{text}</div>
  </div>);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/loading-overlay.jsx